import { toTitleCase } from '@/utils/strings';

type BadgeVariant = 'default' | 'secondary' | 'destructive' | 'outline';

/**
 * Formats payment / processor status enums for display badges.
 * Handles both snake_case (`in_review`) and SCREAMING_SNAKE (`IN_PROCESS`)
 * so Status and Processor Status columns stay visually consistent.
 */
export function formatStatusLabel(status: string): string {
  return toTitleCase(status.replaceAll('_', ' '));
}

export function getStatusVariant(status: string): BadgeVariant {
  switch (status) {
    case 'paid':
      return 'default';
    case 'in_review':
    case 'approved':
    case 'processing':
    case 'scheduled':
    case 'pending':
      return 'secondary';
    case 'failed':
    case 'canceled':
      return 'destructive';
    default:
      return 'outline';
  }
}

export function getInvoicePaymentStatusVariant(
  status: string | undefined,
): BadgeVariant {
  switch (status) {
    case 'paid':
      return 'default';
    case 'partial':
      return 'secondary';
    case 'unpaid':
      return 'outline';
    default:
      return 'outline';
  }
}

export function getProviderStatusVariant(status: string): BadgeVariant {
  switch (status) {
    case 'PAID':
      return 'default';
    case 'IN_PROCESS':
    case 'UNPAID':
      return 'secondary';
    case 'VOID':
    case 'FAILED':
    case 'REFUNDED':
    case 'EXPIRED':
      return 'destructive';
    default:
      return 'outline';
  }
}

export function formatCurrency(value: string | number, currency: string) {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return '—';
  }
  return numericValue.toLocaleString(undefined, {
    style: 'currency',
    currency: currency || 'USD',
  });
}
